<template>
    <b-modal
        id="modalAddAddonTest"
        ref="modalAddAddonTest"
        :lazy="true"
        title-tag="h2"
        title="New Add On Test"
    >
        <b-form>
            <b-form-group label="Item:" class label-cols="3" label-for="item">
                <vet-select
                    id="item"
                    v-model="data.item"
                    module="item-lab"
                    source="ZNLABS"
                    :excludedId="existingLabItemIds"
                    :selectProps="{
                        source: 'ZNLABS',
                        start: null
                    }"
                    placeholder="Item"
                    name="item"
                    multiple
                />
            </b-form-group>

            <b-form-group
                label="Comment: "
                class
                label-cols="3"
                label-for="comment"
            >
                <b-form-textarea
                    id="comment"
                    v-model="data.comment"
                    placeholder="Comment (optional)"
                    rows="3"
                ></b-form-textarea>
            </b-form-group>
        </b-form>
        <div slot="modal-footer" class="w-100">
            <b-button
                v-if="!loading"
                @click="$refs.modalAddAddonTest.hide('cancel')"
                class="float-left"
                variant="secondary"
                >Cancel</b-button
            >
            <div class="float-right">
                <img v-if="loading" src="assets/ajax-loader.gif" />
                <b-button
                    v-if="!loading"
                    @click="save"
                    class="float-left"
                    variant="primary"
                    :disabled="!data.item"
                    >Save</b-button
                >
            </div>
        </div>
    </b-modal>
</template>
<style></style>
<script>
import vetSelect from "@/module/commons/vet-select.vue";
import PatientLabService from "@/services/patient/patient-lab";

export default {
    name: "ModalAddAddonTest",
    components: {
        vetSelect
    },
    data() {
        return {
            loading: false,
            params: [],
            existingLabItemIds: [],
            id: null,
            labPid: null,
            data: {
                item: "",
                comment: ""
            }
        };
    },
    methods: {
        open(params) {
            this.labPid = params.lab_pid;
            this.id = params.id;
            this.getLabDetails();

            this.$refs.modalAddAddonTest.show();
        },
        async save() {
            this.loading = true;

            const itemIds = this.data.item.map(item => item.id);
            const response = await PatientLabService.addAddonTest(this.labPid, {
                item_ids: itemIds,
                comment: this.data.comment
            });

            if (response?.message?.code == 200) {
                this.$emit("reload");
                this._message("Add on test added", "success");
                this.$refs.modalAddAddonTest.hide();
            } else {
                this._message("Failed to add add on test", "danger");
            }

            this.loading = false;
        },
        async getLabDetails() {
            let self = this;

            await this.$store
                .dispatch("patient/getLabDetails", this.id)
                .then(async hasData => {
                    if (hasData.data.lab_items) {
                        self.existingLabItemIds = hasData.data.lab_items.map(
                            item => {
                                return { id: item.id };
                            }
                        );
                    }
                });
        }
    }
};
</script>
